import type { GetSubscriptionByOrder200SubscriptionStatus } from './getSubscriptionByOrder200SubscriptionStatus';

/**
 * 구독 정보
 * @nullable
 */
export type GetSubscriptionByOrder200Subscription = {
  /** 자동 갱신 여부 */
  autoRenewal: boolean;
  /**
   * 연결된 빌링키
   * @nullable
   */
  billingKey?: string | null;
  /**
   * 구독 종료일
   * @nullable
   */
  endDate?: string | null;
  /** 상품 코드 */
  productCode: string;
  /** 구독 시작일 */
  startDate: string;
  /** 구독 상태 */
  status: GetSubscriptionByOrder200SubscriptionStatus;
  /** 구독 ID */
  subscriptionId: string;
} | null;
